import { getAllegroResponsiblePersons } from '../../../api/allegro/responsibleperson/responsiblePerson';
import { AllegroResponsiblePerson } from '../../../api/allegro/responsibleperson/responsiblePersonTypes';
import { fetchAllPages, swallowUnauthorized } from '../utils';

const PAGE_SIZE = 1000;

export default async function fetchAllegroResponsiblePersons(
  marketplaceCode: string,
  signal?: AbortSignal,
): Promise<AllegroResponsiblePerson[]> {
  return swallowUnauthorized(
    () => fetchAllPages(
      async (offset, limit) => {
        const page = await getAllegroResponsiblePersons(marketplaceCode, offset, limit, signal);

        return {
          items: page.responsiblePersons,
          totalCount: page.totalCount,
        };
      },
      PAGE_SIZE,
    ),
    [],
  );
}
